'use client';

import useCallCenter from '@/hooks/useCallCenter';

import SXMLink from '@/shared-components/SXMLink';
import { ShowMore } from '@/ui-components/molecules/ShowMore/ShowMore';
import { LinkInfoItem } from '@/components/molecules/LinkInfoCard';

import styles from './callCenterLink.module.scss';

interface Props {
    asset: SiteLink;
}

export function CallCenterLink(props: Props): React.JSX.Element {
    const isOnline = useCallCenter();

    const asset = props.asset;

    const text = `Our Call Center is ${isOnline ? 'Open' : 'Closed'}`;

    let online = (
        <ShowMore
            id="callcenter"
            showText={text}
            hideText={text}
            activeToggleTextPosition="top"
            contentClassName={styles.callCenter}
            shownClassName={styles.show}
            TagName="span"
        >
            <SXMLink href={asset.fields.href || ''}>{asset.fields.link_text}</SXMLink>
        </ShowMore>
    );

    let offline = <b>{text}</b>;

    if (asset.fields.link_type === 'LinkInfoCard') {
        const icon = {
            url: asset.fields.media?.url,
            width: asset.fields.media?.width,
            height: asset.fields.media?.height,
        };

        online = <LinkInfoItem link={asset.fields as Link} icon={icon} disabled={false} />;
        offline = <LinkInfoItem link={asset.fields as Link} icon={icon} disabled />;
    }

    if (isOnline) return online;

    return offline;
}
